import { Pill, type PillVariant } from '../../../ds/components';

export interface TicketPillProps {
  /** The API's label („neu", „Frist überschritten", „Beim Handwerker", „Abrechnung" …). */
  label: string;
  /** The API's tone; categories pass `neutral`. An unknown value renders neutral. */
  tone: string;
  className?: string | undefined;
}

const variants: readonly PillVariant[] = ['success', 'warning', 'danger', 'info', 'accent', 'neutral'];

function isVariant(value: string): value is PillVariant {
  return (variants as readonly string[]).includes(value);
}

/** Status and category pill of tickets and after-sales cases (A2 pill recipe: 3/9, 11 px medium, tone pairs). */
export function TicketPill({ label, tone, className }: TicketPillProps) {
  return (
    <Pill variant={isVariant(tone) ? tone : 'neutral'} className={className}>
      {label}
    </Pill>
  );
}
